import cn from 'classnames';
import { FC } from 'react';
import { useIntl } from 'react-intl';

import { Select, SelectProps } from '@/shared/ui';

import { DoctorOptionType } from '../../config/types';

import {
  DoctorMultiValueLabel,
  DoctorMultiValueRemove,
  DoctorOption,
} from './DoctorsSelect.components';
import styles from './DoctorsSelect.module.scss';
import { doctorsSelectStyles } from './DoctorsSelect.styles';

export type DoctorsSelectProps = Pick<
  SelectProps<DoctorOptionType>,
  'value' | 'options' | 'error' | 'onChange'
> & {
  className?: string;
};

export const DoctorsSelect: FC<DoctorsSelectProps> = (props) => {
  const { className, value, options, error, onChange } = props;
  const { formatMessage } = useIntl();

  const uniqueOptions = Array.from(
    new Map(options.map((item) => [item.value, item])).values(),
  );

  return (
    <Select
      className={cn(styles.container, className)}
      label={formatMessage({
        id: 'doctorsSelect.label',
        defaultMessage: 'Treating doctor',
      })}
      placeholder={formatMessage({
        id: 'doctorsSelect.placeholder',
        defaultMessage: 'Select doctor',
      })}
      onChange={onChange}
      value={value}
      options={uniqueOptions}
      components={{
        // @ts-expect-error WARN: Hard types conflict
        Option: DoctorOption,
        MultiValueLabel: DoctorMultiValueLabel,
        // @ts-expect-error WARN: Hard types conflict
        MultiValueRemove: DoctorMultiValueRemove,
      }}
      styles={doctorsSelectStyles}
      error={error}
      closeMenuOnSelect={false}
      hideSelectedOptions={false}
      isMulti
      isRequired
    />
  );
};
